import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

/** Números visibles: 1 … 4 5 6 … 10 */
function pageList(page: number, total: number): (number | 'gap')[] {
  if (total <= 7) return Array.from({
    length: total
  }, (_, i) => i + 1);
  const set = new Set([1, total, page - 1, page, page + 1].filter(p => p >= 1 && p <= total));
  const sorted = [...set].sort((a, b) => a - b);
  const out: (number | 'gap')[] = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push('gap');
    out.push(p);
  });
  return out;
}
const base = 'flex h-11 min-w-11 items-center justify-center rounded-full px-3 text-sm font-semibold tabular-nums transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon disabled:cursor-not-allowed disabled:opacity-30';
export function Pagination({
  page,
  totalPages,
  onChange
}: PaginationProps) {
  if (totalPages <= 1) return null;
  return <nav aria-label="Páginas del catálogo" className="mt-12 flex items-center justify-center gap-1.5" data-id="element-361" data-mp="9sw4v63posx8">
      <button type="button" onClick={() => onChange(page - 1)} disabled={page === 1} aria-label="Página anterior" className={`${base} border border-line text-white hover:border-neon/60 hover:text-neon`} data-id="element-362" data-mp="erz9ipfs4x4o">
        <ChevronLeftIcon className="h-4 w-4" data-id="element-363" data-mp="3n8u4zju8zf8q" />
      </button>
      {pageList(page, totalPages).map((p, i) => p === 'gap' ? <span key={`gap-${i}`} className="px-1 text-muted" aria-hidden="true" data-id="element-364" data-mp="3s1wrx94irqfy">
            …
          </span> : <button key={p} type="button" onClick={() => onChange(p)} aria-current={p === page ? 'page' : undefined} aria-label={`Página ${p}`} className={`${base} ${p === page ? 'bg-neon text-ink shadow-neon-btn' : 'border border-line text-white hover:border-neon/60 hover:text-neon'}`} data-id="element-365" data-mp="3iasbe4z73xj0">
            {p}
          </button>)}
      <button type="button" onClick={() => onChange(page + 1)} disabled={page === totalPages} aria-label="Página siguiente" className={`${base} border border-line text-white hover:border-neon/60 hover:text-neon`} data-id="element-366" data-mp="1a2dps8c90drw">
        <ChevronRightIcon className="h-4 w-4" data-id="element-367" data-mp="1xshuyk534ll0" />
      </button>
    </nav>;
}